import { useMemo } from 'react'
import { useRouter } from 'expo-router'
import { CompletionScreen } from '@/src/components/ui/CompletionScreen'
import { useRequiredAppSessionUser } from '@/src/hooks/useRequiredAppSessionUser'
import { getDisplayFirstName } from '@/src/utils/user-name'
import { useTranslation } from 'react-i18next'

const VOICE_ASSESSMENT_FINISH_DASHBOARD_ROUTE =
  '/(protected)/(account)/(tabs)' as const

export default function VoiceAssessmentFinishScreen() {
  const router = useRouter()
  const { t } = useTranslation(['onboarding', 'session'])
  const { authUser, backendUser } = useRequiredAppSessionUser()

  const displayFirstName = useMemo(() => {
    return getDisplayFirstName({
      authUser,
      backendFirstName: backendUser?.firstName,
    })
  }, [authUser, backendUser?.firstName])

  return (
    <CompletionScreen
      heading={t('onboarding:voice_assessment.finish_heading', {
        name: displayFirstName,
      })}
      subheading={t('onboarding:voice_assessment.finish_subheading')}
      buttonLabel={t('session:back_to_dashboard')}
      onPress={() => {
        router.replace(VOICE_ASSESSMENT_FINISH_DASHBOARD_ROUTE)
      }}
    />
  )
}
